import { GrnImport } from './Imports'
const { RoutesMap, GrnMasterList, AddGrnMaster, UpdateGrnMaster } = GrnImport

const GrnRoute = () => {
    return [
        {
            path: RoutesMap.GRN_MASTER_LIST.path,
            element: <GrnMasterList />
        },

        {
            path: RoutesMap.ADD_GRN_MASTER.path,
            element: <AddGrnMaster />
        },

        {
            path: RoutesMap.UPDATE_GRN_MASTER.path,
            element: <UpdateGrnMaster />
        },
    ]
}

export default GrnRoute;
